import React, { Component } from "react";
import { Form, Input, FormGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label } from "reactstrap";
import { injectIntl } from "react-intl";
import { Alert } from "antd";
import Select from "react-select";
import QRCode from "qrcode.react";
import { connect } from "react-redux";
import IntlMessages from "../../helpers/IntlMessages";
import { createRequestQrImage, createRequestQrImageDeepLink } from "../../redux/request/actions";
import {
  fetchPmslistforWeBeePass, sendSMSForWeBeePassShortLink, sendEmailForWeBeePassShortLink
} from "../../services/WeBeeAPI";

class CreateQr extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stateLinks: false,
      statePMS: false,
      linkConfirmed: false,
      showAlert: false,
      showEmail: true,
      showPhone: false,
      allOptions: [],
      selectedOption: null,
      readOnly: false
    };
  }

  componentDidMount() {
    const { hotelConfig } = this.props;
    if (hotelConfig.getPmsListForWebeePass) {
      this.fetchData();
    }
  }

  componentDidUpdate(prevProps) {
    const { shortener } = this.props.requestApp;
    const { shortener: prevShortener } = prevProps.requestApp;
    if (shortener && prevShortener?.data.body.url_short !== shortener.data.body.url_short) {
      if (shortener.data.body.url_long.includes("source=email")) {
        this.sendMail(shortener);
      } else if (shortener.data.body.url_long.includes("source=sms")) {
        this.sendSMS(shortener);
      }
    }
  }

  fetchData = async () => {
    const { hotelConfig: { hotelId, pmsIntegration } } = this.props;
    if (!pmsIntegration) return;

    try {
      const response = await fetchPmslistforWeBeePass(hotelId);
      if (Array.isArray(response)) {
        this.setState({ allOptions: response });
      }
    } catch (error) {
      console.error("fetchPmslist for WeBeePass Error: ", error.message || error);
    }
  };

  onChangeLink = () => {
    this.setState({
      stateLinks: !this.state.stateLinks
    });
  };

  onChangePms = () => {
    this.setState({
      statePMS: !this.state.statePMS
    });
  };

  cancelState = () => {
    this.setState({
      statePMS: false,
      stateLinks: false,
      linkConfirmed: false,
      showAlert: false,
      showEmail: true,
      showPhone: false,
      selectedOption: null,
      readOnly: false
    });
    this.props.togglePmsQR();
  };

  createQrForDeepLink = () => {
    const {
      hotelConfig: { hotelId, bundelIdForMobile, iosAppStoreId, },
      username,
    } = this.props;

    this.onChangeLink();
    const payload = {
      dynamicLinkInfo: {
        domainUriPrefix: "https://hotelapp.page.link",
        link: `https://webee.app?hotel_id=${hotelId}&user_id=${username}`,
        androidInfo: {
          androidPackageName: `${bundelIdForMobile}`
        },
        iosInfo: {
          iosBundleId: `${bundelIdForMobile}`,
          iosAppStoreId: `${iosAppStoreId}`
        },
        navigationInfo: {
          enableForcedRedirect: "true"
        }
      }
    };
    this.props.createRequestQrImageDeepLink(payload);
    this.setState({
      linkConfirmed: !this.state.linkConfirmed
    });
  };

  changeState = (email, phone) => {
    this.setState({
      showEmail: email,
      showPhone: phone
    });
  };

  sendSMS = async (shortener) => {
    const {
      hotelConfig: { hotelName, },
      phoneNumber: phone_number,
      email,
    } = this.props;
    try {
      const shortLink = shortener.data.body.url_short;
      const res = await sendSMSForWeBeePassShortLink({ phone_number, email, shortLink, hotelName });
      if (res) {
        this.setState({
          showAlert: true
        });
      }
    } catch (error) {
      console.error("Send QR SMS Error: ", error);
    }
  }

  sendMail = async (shortener) => {
    const {
      hotelConfig: { hotelName, },
      email,
      intl,
    } = this.props;
    try {
      const language = intl.locale;
      const emails = [email];
      const res = await sendEmailForWeBeePassShortLink({ language, shortener, hotelName, emails });
      if (res) {
        this.setState({
          showAlert: true
        });
      }
    } catch (error) {
      console.error("Send QR Email Error: ", error);
    }
  }

  createQrImage = async (source) => {
    const {
      hotelConfig: {
        hotelId: hotel_id,
        googleCloudApiKey,
        webeePassDomainUrl,
        andorid_bundle_id,
        ios_bundle_id,
        app_store_id,
      },
      phoneNumber: phone_number,
      user_pool_id,
      firstName,
      lastName,
      email,
      checkIn,
      checkOut,
      roomNo,
    } = this.props;
    await this.props.createRequestQrImage({
      hotel_id,
      phone_number,
      user_pool_id,
      firstName,
      lastName,
      email,
      checkIn,
      checkOut,
      roomNo,
      andorid_bundle_id,
      ios_bundle_id,
      app_store_id,
      googleCloudApiKey,
      webeePassDomainUrl,
      source
    });
  }

  handleChangeSelect = selectedOption => {
    this.setState({
      selectedOption: {
        FirstName: selectedOption.FirstName ? selectedOption.FirstName : " ",
        LastName: selectedOption.LastName ? selectedOption.LastName : " ",
        Email: selectedOption.Email ? selectedOption.Email : " ",
        Mobile: selectedOption.Mobile ? selectedOption.Mobile : " ",
        Checkindate: selectedOption.Checkindate ? selectedOption.Checkindate : " ",
        Checkoutdate: selectedOption.Checkoutdate ? selectedOption.Checkoutdate : " ",
        RoomNo: selectedOption.RoomNo ? selectedOption.RoomNo : " "
      },
      showEmail: true,
      showPhone: false,
      readOnly: true
    });

    if (selectedOption && !selectedOption.Email && selectedOption.Mobile) {
      this.setState({ showEmail: false, showPhone: true });
    }

    const inputArray = document.getElementById("createQrForm").getElementsByTagName("input");

    for (let i = 0; i < inputArray.length; i += 1) {
      const elem = document.getElementById(inputArray[i].id);
      elem.addEventListener("change", event => {
        this.props.handleChangeQR(event);
      });

      const event = new Event("change", { bubbles: true });
      setTimeout(() => elem.dispatchEvent(event), 1);
    }
    setTimeout(() => {
      this.setState({ selectedOption: null });
    }, 500);
  };

  render() {
    const { hotelConfig, requestApp, errors, valid, isConfirmed, pmsQr, linkQr, phoneNumber, email } = this.props;
    const { linkConfirmed, showAlert, showEmail, showPhone, allOptions, selectedOption, readOnly } = this.state;
    const { messages } = this.props.intl;
    let QRImage;
    let QRImageForDeepLink;
    let createQrForPMS;
    let createQrForLinks;
    const messageError = <IntlMessages id="createQr.error" />;

    if (
      isConfirmed &&
      isConfirmed === true &&
      requestApp.createQrImageLoading === false &&
      requestApp.createImage &&
      requestApp.createImageerror === "" &&
      pmsQr &&
      pmsQr === true
    ) {
      const createImageQrContent = JSON.stringify(requestApp.createImage.data.body.url_short);
      QRImage = (
        <div className="text-center">
          <QRCode id={createImageQrContent} value={createImageQrContent} size={290} level="H" />
        </div>
      );
    }

    if (requestApp.createQrImageDeepLinkLoading === false && requestApp.createQrImageDeepLink && requestApp.createQrImageDeepLinkError === "") {
      const createImageQrContentDeepLink = requestApp.createQrImageDeepLink.data.shortLink;
      QRImageForDeepLink = (
        <div className="text-center">
          <QRCode id={createImageQrContentDeepLink} value={createImageQrContentDeepLink} size={290} level="H" />
        </div>
      );
    }

    const createQrForOnlyLinks = (
      <div>
        <ModalBody>
          {!linkConfirmed && requestApp.createQrImageDeepLinkLoading === false ? (
            <div className="text-center">
              <Button color="primary" onClick={() => this.createQrForDeepLink()}>
                <IntlMessages id="createQr.create_link" />
              </Button>
            </div>
          ) : linkConfirmed && requestApp.createQrImageDeepLinkLoading === true ? (
            <div className="loading" />
          ) : linkConfirmed && requestApp.createQrImageDeepLinkLoading === false && requestApp.createQrImageDeepLinkError !== "" ? (
            <div>
              <Alert message={messageError} type="error" className="mb-1" />
            </div>
          ) : (
            <div>{QRImageForDeepLink}</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.cancelState}>
            <IntlMessages id="request.cancel" />
          </Button>
        </ModalFooter>
      </div>
    );

    if ((pmsQr && pmsQr === true) || !hotelConfig.createQrForAppStore) {
      createQrForPMS = (<>
        <ModalBody>
          {!isConfirmed && requestApp.createQrImageLoading === false ? (
            <Form id="createQrForm" onSubmit={this.props.handleChangeClickQR}>
              {hotelConfig.getPmsListForWebeePass ? (
                <div className="mb-4">
                  <Label for="exampleText" style={{ marginBottom: "auto" }}>
                    <IntlMessages id="forms.select_pms" />
                  </Label>
                  <Select
                    id="selectDropdown"
                    value={selectedOption}
                    onChange={this.handleChangeSelect}
                    options={allOptions}
                    isSearchable
                    getOptionLabel={option => `${option.FirstName} ${option.LastName}`}
                    placeholder="Select a person"
                  />
                </div>
              ) : (
                ""
              )}

              <FormGroup>
                <Label for="exampleText" style={{ marginBottom: "auto" }}>
                  <IntlMessages id="forms.firstname" />
                </Label>
                <Input
                  type="text"
                  name="firstName"
                  id="firstName"
                  placeholder={messages["forms.firstname"]}
                  maxLength="30"
                  value={selectedOption && selectedOption.FirstName ? selectedOption.FirstName : this.props.firstName}
                  onChange={this.props.handleChangeQR}
                  readOnly={readOnly}
                />
                {errors.firstName.length > 0 && errors.firstName !== "required" ? (
                  <span style={{ color: "red" }}>
                    <IntlMessages id={errors.firstName} />
                    <div> </div>
                  </span>
                ) : (
                  ""
                )}
                <Label for="exampleText" className="mt-2">
                  <IntlMessages id="forms.lastname" />
                </Label>
                <Input
                  type="text"
                  name="lastname"
                  id="lastName"
                  maxLength="30"
                  value={selectedOption && selectedOption.LastName ? selectedOption.LastName : this.props.lastName}
                  onChange={this.props.handleChangeQR}
                  placeholder={messages["forms.lastname"]}
                  readOnly={readOnly}
                />
                {errors.lastName.length > 0 && errors.lastName !== "required" ? (
                  <span style={{ color: "red" }}>
                    <IntlMessages id={errors.lastName} />
                    <div> </div>
                  </span>
                ) : (
                  ""
                )}
                <Label className="mt-2 d-block" style={{ fontStyle: "italic" }}>
                  {" *"} <IntlMessages id="forms.select_contact" />
                </Label>
                <div role="group" className="btn-group" style={{ zIndex: "0" }}>
                  <Button
                    color="primary"
                    type="button"
                    className={`default btn btn-primary btn-xs ${this.state.showEmail ? "active" : ""}`}
                    onClick={() => this.changeState(true, false)}
                  >
                    Email
                  </Button>
                  <Button
                    color="primary"
                    className={`default btn btn-primary btn-xs ${this.state.showPhone ? "active" : ""}`}
                    onClick={() => this.changeState(false, true)}
                  >
                    Phone Number
                  </Button>
                </div>

                <div style={showEmail ? { visibility: "visible", position: "relative" } : { visibility: "hidden", position: "absolute" }}>
                  <Label className="mt-2">
                    <IntlMessages id="forms.email" />
                  </Label>
                  <Input
                    type="text"
                    id="email"
                    placeholder={messages["forms.email"]}
                    onChange={this.props.handleChangeQR}
                    value={selectedOption && selectedOption.Email ? selectedOption.Email : email}
                  />
                  {errors.email.length > 0 && errors.email !== "required" ? (
                    <span style={{ color: "red" }}>
                      <IntlMessages id={errors.email} />
                      <div> </div>
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <div style={showPhone ? { visibility: "visible", position: "relative" } : { visibility: "hidden", position: "absolute" }}>
                  <Label className="mt-2">
                    <IntlMessages id="booking.phone-placeholder" />
                  </Label>
                  <Input
                    type="text"
                    id="phoneNumber"
                    placeholder={messages["forms.phone_number"]}
                    onChange={this.props.handleChangeQR}
                    value={selectedOption && selectedOption.Mobile ? selectedOption.Mobile : phoneNumber}
                  />
                  {errors.phoneNumber.length > 0 && errors.phoneNumber !== "required" ? (
                    <span style={{ color: "red" }}>
                      <IntlMessages id={errors.phoneNumber} />
                      <div> </div>
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <Label className="mt-2">
                  <IntlMessages id="forms.checkin" />
                </Label>
                <Input
                  type="date"
                  id="checkIn"
                  placeholder={messages["forms.checkin"]}
                  onChange={this.props.handleChangeQR}
                  value={selectedOption && selectedOption.Checkindate ? selectedOption.Checkindate.slice(0, 10) : this.props.checkIn}
                  readOnly={readOnly}
                />
                <Label className="mt-2">
                  <IntlMessages id="forms.checkout" />
                </Label>
                <Input
                  type="date"
                  id="checkOut"
                  placeholder={messages["forms.checkout"]}
                  onChange={this.props.handleChangeQR}
                  value={selectedOption && selectedOption.Checkoutdate ? selectedOption.Checkoutdate.slice(0, 10) : this.props.checkOut}
                  readOnly={readOnly}
                />
                <Label className="mt-2">
                  <IntlMessages id="forms.room_number" />
                </Label>
                <Input
                  type="text"
                  id="roomNo"
                  placeholder={messages["forms.room_number"]}
                  onChange={this.props.handleChangeQR}
                  value={selectedOption && selectedOption.RoomNo ? selectedOption.RoomNo : this.props.roomNo}
                  readOnly={readOnly}
                />
                {errors.roomNo.length > 0 && errors.roomNo !== "required" ? (
                  <span style={{ color: "red" }}>
                    <IntlMessages id={errors.roomNo} />
                  </span>
                ) : (
                  ""
                )}
              </FormGroup>
            </Form>
          ) : isConfirmed && requestApp.createQrImageLoading === true ? (
            <div className="loading" />
          ) : isConfirmed && requestApp.createQrImageLoading === false && requestApp.createImageerror !== "" ? (
            <div>
              <Alert message={messageError} type="error" className="mb-1" />
            </div>
          ) : (
            ""
          )}
          {QRImage}
          {QRImage &&
            <p className="mt-4 mb-1"><b>
              <IntlMessages id="request.webeepass_message" />
            </b></p>
          }
          {showAlert && (
            <Alert
              message={<p>Message just sent!</p>}
              type="success"
              style={{ fontSize: "14px", marginTop: "5px", display: "flex", justifyContent: "center" }}
            />
          )}
        </ModalBody>

        {QRImage
          ?
          (
            <ModalFooter className="justify-content-around">
              {email && (
                <Button color="primary" onClick={() => this.createQrImage("email")}>
                  <IntlMessages id="forms.send_email" />
                </Button>
              )}
              {phoneNumber && (
                <Button color="primary" onClick={() => this.createQrImage("sms")}>
                  <IntlMessages id="forms.send_sms" />
                </Button>
              )}
              <Button color="secondary" onClick={this.cancelState}>
                <IntlMessages id="modal.close" />
              </Button>
            </ModalFooter>
          )
          :
          (
            <ModalFooter>
              <Button color="primary" form="createQrForm" block key="submit" type="submit" disabled={!valid}>
                <IntlMessages id="request.create_qr" />
              </Button>{" "}
              <Button color="secondary" onClick={this.cancelState}>
                <IntlMessages id="request.cancel" />
              </Button>
            </ModalFooter>
          )}
      </>);
    }
    if (linkQr && linkQr === true) {
      if (!requestApp.createQrImageDeepLink && !this.state.linkConfirmed) {
        this.createQrForDeepLink();
      }
      createQrForLinks = (
        <div>
          <ModalBody>
            {requestApp.createQrImageDeepLink && requestApp.createQrImageDeepLinkLoading == false ? (
              <div>{QRImageForDeepLink}</div>
            ) : requestApp.createQrImageDeepLinkError &&
              requestApp.createQrImageDeepLinkError !== "" &&
              requestApp.createQrImageDeepLinkLoading == false ? (
              <div>
                <Alert message={messageError} type="error" className="mb-1" />
              </div>
            ) : requestApp.createQrImageDeepLinkLoading == true ? (
              <div className="loading" />
            ) : (
              ""
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.cancelState}>
              <IntlMessages id="request.cancel" />
            </Button>
          </ModalFooter>
        </div>
      );
    }

    return (
      <div
        style={
          this.props.modalQR
            ?
            {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(10px)",
              zIndex: 1
            }
            : {}
        }
      >
        <div>
          <Modal isOpen={this.props.modalQR}>
            <ModalHeader>
              <IntlMessages id="request.modalCreateQR" />
            </ModalHeader>
            <div>
              {hotelConfig.createQrForPms && hotelConfig.createQrForPms === true && this.props.pmsQr && this.props.pmsQr === true ? (
                <div>{createQrForPMS}</div>
              ) : hotelConfig.createQrForAppStore && hotelConfig.createQrForAppStore === true && this.props.linkQr && this.props.linkQr === true ? (
                <div>{createQrForLinks}</div>
              ) : !hotelConfig.createQrForPms && hotelConfig.createQrForAppStore && hotelConfig.createQrForAppStore === true ? (
                <div>{createQrForOnlyLinks}</div>
              ) : (
                ""
              )}
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, requestApp, auth }) => {
  const { username } = auth.authData;
  return {
    hotelConfig: settings.hotelConfig,
    requestApp,
    username,
  };
};
export default injectIntl(
  connect(
    mapStateToProps,
    {
      createRequestQrImage,
      createRequestQrImageDeepLink
    }
  )(CreateQr)
);
